import script from "./delete-dialog.vue?vue&type=script&setup=true&lang=js"
export * from "./delete-dialog.vue?vue&type=script&setup=true&lang=js"

import "./delete-dialog.vue?vue&type=style&index=0&id=69c20a8c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69c20a8c"]])

export default __exports__